import React from 'react'
import styled, { css } from 'styled-components'

const width = '19'
const height = '16'
const viewBox = '0 0 19 16'

const getDimensions = () => ({
  height,
  width
})

const getDimensionsCss = () => css`
  width: ${width}px;
  height: ${height}px;
`

const Image = styled.svg`
  ${({ noStyles }) => (!noStyles ? getDimensionsCss() : null)}
`

const defaultProps = {
  children: [
    <g key="g" fill="#202D36" clipPath="url(#a)">
      <path d="M17.843 9.192h.664c.341 0 .524-.203.486-.551a9.87 9.87 0 0 0-.867-3.126A9.924 9.924 0 0 0 16.948 3.6c-.234-.3-.49-.318-.757-.046-.313.318-.626.637-.938.957-.216.22-.228.429-.04.677a7.392 7.392 0 0 1 1.451 3.589c.033.26.195.41.454.415.24.005.483 0 .725 0v-.001ZM1.167 9.192h.7c.265-.002.433-.154.466-.417a7.412 7.412 0 0 1 1.45-3.589c.19-.251.181-.45-.039-.676-.316-.327-.637-.649-.956-.973-.238-.242-.507-.23-.717.035A9.866 9.866 0 0 0 .653 6.019a10.06 10.06 0 0 0-.65 2.61c-.042.355.138.561.486.563h.678ZM17.828 10.174h-.712c-.248.001-.42.153-.45.403a7.425 7.425 0 0 1-1.475 3.63c-.155.206-.147.426.03.61.34.35.682.698 1.025 1.044.2.202.483.178.665-.052a9.906 9.906 0 0 0 1.455-2.526c.32-.817.523-1.665.624-2.538.043-.37-.133-.571-.5-.57h-.663l.001-.001ZM1.154 10.174H.48c-.334 0-.514.208-.476.546.065.577.173 1.145.334 1.702a9.746 9.746 0 0 0 1.742 3.376c.203.256.473.267.7.035l.963-.983c.217-.223.232-.424.041-.677a7.387 7.387 0 0 1-1.451-3.587c-.034-.262-.197-.41-.454-.414h-.724v.002ZM9.98 1.188v.702c0 .284.142.455.42.49.88.11 1.713.371 2.485.808.357.202.693.441 1.03.676.241.17.44.167.646-.042l.965-.982c.24-.245.223-.521-.043-.738A9.456 9.456 0 0 0 10.8.038a3.983 3.983 0 0 0-.355-.036c-.272-.014-.46.168-.464.448-.003.246 0 .493 0 .738ZM8.489.003a9.327 9.327 0 0 0-2.476.619 9.563 9.563 0 0 0-2.466 1.455c-.313.253-.326.509-.043.796.308.312.615.625.92.938.218.223.42.238.663.047A7.099 7.099 0 0 1 8.593 2.38c.28-.036.425-.203.425-.486V.465c0-.3-.191-.48-.53-.464v.002ZM9.511 12.252a.967.967 0 0 0 .891-1.331c-.217-.535-.471-1.054-.722-1.575-.613-1.268-1.234-2.53-1.852-3.797-.037-.075-.075-.147-.173-.12-.107.03-.097.12-.082.204.146.896.288 1.794.44 2.689.176 1.03.356 2.06.545 3.088.095.515.476.839.955.84l-.002.002Z" />
    </g>,
    <defs key="defs">
      <clipPath id="a">
        <path fill="#fff" d="M19 0H0v16h19z" />
      </clipPath>
    </defs>
  ],
  viewBox
}

export default Object.assign(Image, {
  getDimensions,
  getDimensionsCss,
  defaultProps,
  displayName: 'IconSpeedometer'
})
